import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-acceuil-card',
  templateUrl: './acceuil-card.component.html',
  styleUrls: ['./acceuil-card.component.css']
})
export class AcceuilCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
